<template>
  <div class="container">
    <div class="row">
      <h4 v-if="title">{{ title }}</h4>
    </div>
    <div class="row">
      <div class="col-md-10">
        <div class="input-group mb-3">
          <input
            v-model.trim="search"
            type="text"
            class="form-control"
            placeholder="Buscar opción"
            aria-label="Buscar opción"
            @keyup="debounceLoadOptions"
            aria-describedby="input-search"
          >
          <div class="input-group-append">
            <button
              class="btn btn-outline-secondary"
              type="button"
              v-b-tooltip="'Agregar nueva opción'"
              v-on:click="addOptionNew()"
            >
              <feather-icon icon="PlusIcon"/>
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-2 cursor-pointer">
        <span
          v-bind:class="{
           'badge-info': showHide ,
           'badge-warning':!showHide
        }"
          class="badge"
          v-on:click="showHidesOptionsTogle()"
        >
        <feather-icon
          v-if="!showHide"
          icon="EyeIcon"
          v-b-tooltip="'Mostrar opciones ocultas'"
        />
        <feather-icon
          v-else
          icon="EyeOffIcon"
          v-b-tooltip="'Ocultar opciones ocultas'"
        />
        </span>
        <span  @click="migrateOptions()">
          <feather-icon
            icon="SendIcon"
            class="mr-1 cursor-pointer float-right ml-2"
            v-b-tooltip="'Migrar Opciones visibles'"
          />
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-spinner
          v-if="loading"
          key="primary"
          class="mr-1"
          variant="primary"
        />
      </div>
      <div v-show="!loading" class="col-12" style="max-height: 80vh; overflow: scroll">
        <ul class="list-group mt-5">
          <li
            :key="'list-option-'+option.opcionId"
            :id="'list-option-'+option.opcionId"
            v-for="option in filteredOptions"
            class="list-group-item justify-content-between align-content-center"
            :class="`habilitado-${option.deshabilitado} nivel-${option.nivel}` "
          >
            <div>
              <div class="row">
                <div class="col-md-12 col-12 mt-2">
                  <span class="d-inline-block text-truncate w-75">
                    <span
                      v-b-tooltip="'Orden: '+option.orden"
                      @click="copyToClipboard(option.orden)"
                    >
                      <b>O:</b> {{ option.orden }}
                    </span>
                    <span
                      v-b-tooltip="'Nivel: '+option.nivel"
                      @click="copyToClipboard(option.nivel)"
                    >
                      <b>N:</b> {{ option.nivel }}
                    </span>
                    <span
                      v-b-tooltip="'Descripción: '+option.descripcion"
                      @click="copyToClipboard(option.descripcion)"
                    >
                      <b>D:</b> {{ option.descripcion }}
                    </span>
                  </span> <br>
                  <span class="d-inline-block text-truncate w-75">
                    <b v-b-tooltip="'Valor'">
                      V:
                    </b>
                    <span
                      v-b-tooltip="'Valor: '+option.valor"
                      @click="copyToClipboard(option.valor)"
                    >
                      {{ option.valor }}
                    </span>
                  </span>
                  <vs-icon
                    class="material-icons mr-1 cursor-pointer float-right ml-2"
                    icon="fingerprint"
                    @click="copyToClipboard(option.opcionId)"
                    v-b-tooltip="'Copiar id de opcion'"
                  />
                  <feather-icon
                    @click="migrateOption(option)"
                    icon="SendIcon"
                    class="mr-1 cursor-pointer float-right ml-2"
                    v-b-tooltip="'Migrar Opción'"
                  />
                  <feather-icon
                    v-if="option.deshabilitado == OPTION_STATES.ACTIVE
                    && option.nivel === OPTION_LEVELS.GLOBAL"
                    @click="deleteOption(option)"
                    icon="AlertCircleIcon"
                    color="red"
                    class="mr-1 cursor-pointer float-right ml-2"
                    v-b-tooltip="'Ocultar opción para TODOS'"
                    v-has-permission="'FEB99'"
                  />
                  <feather-icon
                    v-if="option.deshabilitado == OPTION_STATES.ACTIVE"
                    @click="deleteOptionCompany(option)"
                    icon="TrashIcon"
                    color="red"
                    class="mr-1 cursor-pointer float-right ml-2"
                    v-b-tooltip="'Ocultar opción para la empresa'"
                  />

                  <feather-icon
                    v-if="option.deshabilitado == OPTION_STATES.INACTIVE"
                    @click="activeOption(option, OPTION_LEVELS.GLOBAL)"
                    icon="AlertCircleIcon"
                    color="red"
                    class="mr-1 cursor-pointer float-right ml-2"
                    v-b-tooltip="'Volver a mostrar la opción para TODOS'"
                    v-has-permission="'FEB99'"
                  />

                  <feather-icon
                    v-if="option.deshabilitado == OPTION_STATES.INACTIVE"
                    @click="activeOption(option)"
                    icon="EyeIcon"
                    color="green"
                    class="mr-1 cursor-pointer float-right ml-2"
                    v-b-tooltip="'Volver a mostrar la opcion en la empresa'"
                  />

                  <feather-icon
                    class="mr-1 cursor-pointer float-right ml-2"
                    icon="CopyIcon"
                    v-b-tooltip="'Copiar'"
                    @click="copyToOptionNew(option)"
                  />
                  <b-icon
                    v-if="option.deshabilitado == OPTION_STATES.ACTIVE"
                    class="mr-1 cursor-pointer float-right ml-2"
                    icon="pencil"
                    @click="editOption(option)"
                    v-b-tooltip="'Editar'"
                  />
                </div>
              </div>

            </div>
          </li>
        </ul>
      </div>
      <div class="col-12 mt-5 mb-3" v-show="!loading">
        <fb-paginacion
          :total="pagination.pages"
          :max="10"
          v-model="page"
          @change="handlePageChange"
        />
      </div>
    </div>
    <option-edition-modal
      ref="option-modal"
      :value-type-config="valueTypeConfig"
      :extra-type-render="extraTypeRender"
      v-on:saved="savedOption"
    />
    <option-migration-modal ref="option-migration-modal"/>
  </div>
</template>

<script>

import OptionConfigurationMixins, {
  OPTION_LEVELS
} from '@/febos/global/empresas/componentes/options/OptionConfigurationsMixin';
import OptionEditionModal from '@/febos/global/empresas/componentes/options/OptionEditionModal';
import OptionMigrationModal from '@/febos/global/empresas/componentes/options/OptionMigrationModal';
import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';
import FbPaginacion from '@/febos/chile/_vue/componentes/FbPaginacion';

export default {
  name: 'OptionsConfigurationsList',
  components: {
    FbPaginacion,
    OptionEditionModal,
    OptionMigrationModal,
  },
  mixins: [OptionConfigurationMixins, CopyToClipboard],
  data() {
    return {
      OPTION_LEVELS
    };
  },
  methods: {
    handlePageChange(page) {
      this.loadOptions(page);
    },
    migrateOptions() {
      this.$refs['option-migration-modal'].setOption(this.filteredOptions);
      this.$refs['option-migration-modal'].show();
    }
  }
};
</script>
<style scoped>
.habilitado-1 {
  border-left: 4px red solid;
}

.habilitado-0 {
  border-left: 4px green solid;
}
.nivel-0 {
  border-left: 5px orange solid !important;
}
</style>
